import styled from "styled-components";
import { Select, Col } from "antd";

export const LanguageSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const LevelSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (min-width: 320px) and (max-width: 768px) {
    justify-content: flex-start;
  }
  @media (min-width: 769px) {
    justify-content: flex-end;
  }
`;

export const SelectorLabel = styled(Col)`
  display: flex;
  font-size: 16px;
  color: white;
  font-weight: bold;
  align-items: center;
  margin-right: 10px;
  text-align: left;
`;

export const LevelSelector = styled(Select)`
  height: 36px;
  font-size: 15px;
  color: black;
  width: 251px;
  flex-grow: 1;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;
